const routes = [
  {
    path: '/monitor/labels/:startDate?/:endDate?',
    props: true,
    component: () => import('@/views/monitor/scanned/Labels.vue')
  }
]

export default routes
